module.exports = __webpack_public_path__ + "static/media/excelIcon.9912d628.svg";